import React, { useState } from "react";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Header from "../../sharedScreens/Header";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { FormikValues, useFormik } from "formik";
import { ManageBookingSchema } from "../../validations/Schema";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MoreOutlinedIcon from "@mui/icons-material/MoreOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

const Fop = () => {
  const typeList = [
    { label: "All", value: "All" },
    { label: "Live", value: "Live" },
    { label: "To be Cancelled", value: "To be Cancelled" },
    { label: "Cancelled", value: "Cancelled" },
  ];

  const paymentMode = [
    { label: "TopUp", value: "TopUp" },
    { label: "Payment Gateway", value: "Payment Gateway" },
    { label: "Credit", value: "Credit" },
  ];

  const initialValues = {
    spnr: "",
    hotelConfirmation: "",
    fromDate: "",
    toDate: "",
    searchBy: "",
    firstName: "",
    lastName: "",
    customerName: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ManageBookingSchema,
    onSubmit(values, formikHelpers) {
      console.log("Form submitted with values:", values);
    },
  });

  const [activeTab, setActiveTab] = useState("home");
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">FOP</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <div className="card card-custom ">
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label="Mapping"
                          value="1"
                          className={`tab ${
                            activeTab === "home" ? "active" : ""
                          }`}
                        />
                        <Tab
                          label="View Mapping"
                          value="2"
                          className={`tab ${
                            activeTab === "about" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("about")}
                        />
                        <Tab
                          label="Card Details"
                          value="3"
                          className={`tab ${
                            activeTab === "service" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("service")}
                        />
                      </TabList>
                      <div className="tab-content">
                        <TabPanel value="1">
                          <div className="row mt-4">
                            <div className="card card-grid min-w-full">
                              <div className="card-body">
                                <div
                                  data-datatable="true"
                                  data-datatable-page-size={20}
                                  className="datatable-initialized"
                                >
                                  <div className="scrollable-x-auto">
                                    <div
                                      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                      data-datatable-spinner="true"
                                      style={{ display: "none" }}
                                    >
                                      <div className="flex items-center gap-2 px-4 py-2 font-medium leading-none text-2sm border border-gray-200 shadow-default rounded-md text-gray-500 bg-light">
                                        <svg
                                          className="animate-spin -ml-1 h-5 w-5 text-gray-600"
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                        >
                                          <circle
                                            className="opacity-25"
                                            cx={12}
                                            cy={12}
                                            r={10}
                                            stroke="currentColor"
                                            strokeWidth={3}
                                          />
                                          <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                          />
                                        </svg>
                                        Loading...
                                      </div>
                                    </div>
                                    <table
                                      className="table table-border"
                                      data-datatable-table="true"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="min-w-[150px]">
                                            Assign Card Type
                                          </th>
                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Business Unit
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Client Name
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[170px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                CRS Name
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Airline Name
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Airport Type
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>

                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Cabin Type
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[150px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Amount Limit
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[170px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Assign Limit Type
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="min-w-[170px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Assign Card Number
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="w-[170px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                More
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                          <th className="w-[170px]">
                                            <span className="sort">
                                              <span className="sort-label text-gray-700 font-normal">
                                                Add
                                              </span>
                                              <span className="sort-icon"></span>
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                         
                                            <td className="text-gray-800 font-normal">
                                              <MuiSearchSelect
                                                placeholder={"commission"}
                                                label="commission"
                                                options={[]}
                                                onChange={function (
                                                  value: string,
                                                  id: string,
                                                  data: any
                                                ): void {
                                                  throw new Error(
                                                    "Function not implemented."
                                                  );
                                                }}
                                                value={""}
                                              />
                                            </td>
                                 
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal">
                                            <MuiSearchSelect
                                              placeholder={"commission"}
                                              label="commission"
                                              options={[]}
                                              onChange={function (
                                                value: string,
                                                id: string,
                                                data: any
                                              ): void {
                                                throw new Error(
                                                  "Function not implemented."
                                                );
                                              }}
                                              value={""}
                                            />
                                          </td>
                                          <td className="text-gray-800 font-normal text-center">
                                            <MoreOutlinedIcon className="text-primary " />
                                          </td>
                                          <td className="text-gray-800 font-normal text-success text-center">
                                            <AddCircleOutlineOutlinedIcon />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                               
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn"
                              label="Clear"
                              onClick={() => formik.resetForm()}
                              type="submit"
                            />
                            <MuiButton
                              className="get-btn"
                              label="Create"
                              onClick={() => {}}
                              type="submit"
                            />
                          </div>
                        </TabPanel>

                        <TabPanel value="2">
                          <div className="row mt-3">
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Card Type"
                                label={"Card Type"}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.spnr &&
                                  Boolean(formik.errors.spnr)
                                }
                                errorText={
                                  formik.touched.spnr && formik.errors.spnr
                                    ? formik.errors.spnr
                                    : ""
                                }
                                onChange={formik.handleChange}
                                onBlur={() =>
                                  formik.setFieldTouched("spnr", true)
                                }
                                value={formik.values.spnr}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder="CRS"
                                label={"CRS"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>

                           
                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder="Airline Name"
                                label={"Airline Name"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder="Business Unit"
                                label={"Business Unit"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder="Client Name"
                                label={"Client Name"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiSearchSelect
                                placeholder="Status"
                                label={"Status"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                          </div>
                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn"
                              label="Clear"
                              onClick={() => formik.resetForm()}
                              type="submit"
                            />
                            <MuiButton
                              className="get-btn"
                              label="Get"
                              onClick={() => {}}
                              type="submit"
                            />
                          </div>
                        </TabPanel>
                        <TabPanel value="3">
                          <div className="row mt-3">
                            <div className="col-md-4 mb-3 ">
                              <MuiInput
                                placeholder="Card Type"
                                label={"Card Type"}
                                isRequired={true}
                                isInvalid={
                                  formik.touched.spnr &&
                                  Boolean(formik.errors.spnr)
                                }
                                errorText={
                                  formik.touched.spnr && formik.errors.spnr
                                    ? formik.errors.spnr
                                    : ""
                                }
                                onChange={formik.handleChange}
                                onBlur={() =>
                                  formik.setFieldTouched("spnr", true)
                                }
                                value={formik.values.spnr}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Business Unit"
                                label={"Business Unit"}
                              />
                            </div>

                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Client Name"
                                label={"Client Name"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Card Number  New"
                                label={"Card Number  New"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Bank Name"
                                label={"Bank Name"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Card Name"
                                label={"Card Name"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="CVV"
                                label={"CVV"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Expiry"
                                label={"Expiry"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Holder Name"
                                label={"Holder Name"}
                              />
                            </div>
                            <div className="col-md-4 mb-3">
                              <MuiInput
                                placeholder="Status"
                                label={"Status"}
                              />
                            </div>

                            <div className="user-button w-full">
                              <MuiButton
                                className="clear-btn"
                                label="Clear"
                                onClick={() => formik.resetForm()}
                                type="submit"
                              />
                              <MuiButton
                                className="get-btn"
                                label="Save"
                                onClick={() => {}}
                                type="submit"
                              />
                            </div>
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Fop;
